module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "theme": "dark",
      "lass": "el-menu-demo",
      "mode": "horizontal"
    }
  }, [(_vm.teacher.authenticated) ? _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/attendance"
    }
  }, [_vm._v("Attendance")])], 1) : _vm._e(), _vm._v(" "), (!_vm.teacher.authenticated) ? _c('el-menu-item', {
    attrs: {
      "index": "10"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/teacherlogin"
    }
  }, [_vm._v("Teacher Login")])], 1) : _vm._e(), _vm._v(" "), (_vm.teacher.authenticated) ? _c('el-menu-item', {
    attrs: {
      "index": "12"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Logout")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0f43b74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 272
// module chunks = 3